import { TFunction } from 'i18next';
import { IManageUniqueCodeForm } from 'models/charge-station';
import { Common } from 'utils/constants';
import * as Yup from 'yup';

export const ManageUniqueCodeValidationSchema = (t: TFunction) => {
    return Yup.object().shape({
        unique_code: Yup.string()
            .required('required')
            .matches(Common.RegularExpression.AlphaNumericRegex, t('payByWeb.errors.unique_code.valid')),
    }) as Yup.SchemaOf<IManageUniqueCodeForm>;
};
